/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AppointmentTreatmentHistoryEntry } from './appointmentTreatmentHistoryEntry';


import {ValidatorFn, Validators} from "@angular/forms";

export interface PaginatedTreatmentHistoryEntryList { 
    next?: string | null;
    previous?: string | null;
    results: Array<AppointmentTreatmentHistoryEntry>;
}
export const PaginatedTreatmentHistoryEntryList_next_Validators: ValidatorFn[] =
    [ ];

export const PaginatedTreatmentHistoryEntryList_previous_Validators: ValidatorFn[] =
    [ ];

export const PaginatedTreatmentHistoryEntryList_results_Validators: ValidatorFn[] =
    [  Validators.required, ];


